$ (document).ready (function () {
	$ (function () {
		$ ('[data-toggle="tooltip"]').tooltip ();
	});

	$ ('#post-comments .reply').click (function (e) {
		$ ('#reply-name-container').slideDown ();
		$ ('#reply-name-container .cm-name').html ($ (this).closest ('article').find ('.cm-name').first ().html ());
		$ ('#reply-name-container .cm-text').html ($ (this).closest ('article').find ('.comment-body').first ().html ());
		$ ('#comment_parent').val($(this).attr('data-id')) ;
		e.preventDefault ();
	});

	$ ('#post-print').click (function (e) {
		e.preventDefault ();
		var printContents = document.getElementById ('post').innerHTML;
		var originalContents = document.body.innerHTML;
		document.body.innerHTML = printContents;
		window.print ();
		document.body.innerHTML = originalContents;
	});
});